'use strict';

angular.module('licensure.services')
    .factory('ServiceUserLongevityCredits', ['$http', '$q', function ($http, $q) {
        var save = function (service_user_longevity_credit) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/ServiceUserLongevityCredits/';
            if (!isUndefined(service_user_longevity_credit.id)) {
                method = 'PUT'
                url += service_user_longevity_credit.id
            }

            $http({
                method: method,
                url: url,
                data: {
                    service_user_longevity_credit: service_user_longevity_credit
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ServiceUserLongevityCredits', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getCount: function(args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ServiceUserLongevityCredits/getcount', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise; 
            },

            save: save,

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/ServiceUserLongevityCredits/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;